import { z } from "zod";

/** Every endpoint answers with one of these two shapes. */
export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    /** Field-level messages, keyed by form field path. */
    fields: z.record(z.string(), z.string()).optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof apiErrorSchema>;

export function envelope<T extends z.ZodTypeAny>(data: T) {
  return z.object({ data });
}

export type ApiEnvelope<T> = { data: T };

export const API_ERROR_CODES = {
  VALIDATION_FAILED: "VALIDATION_FAILED",
  NOT_FOUND: "NOT_FOUND",
  UNAUTHORIZED: "UNAUTHORIZED",
  BOOKINGS_CLOSED: "BOOKINGS_CLOSED",
  DATES_UNAVAILABLE: "DATES_UNAVAILABLE",
  RATE_LIMITED: "RATE_LIMITED",
  INTERNAL: "INTERNAL",
} as const;

export type ApiErrorCode = (typeof API_ERROR_CODES)[keyof typeof API_ERROR_CODES];
